<template>
  <div class="mc-loading">
    <slot></slot>
    <div
        class="mc-loading__animation"
        v-if="loading">
      <div class="mc-loading__box">
        <i class="mc-loading__i"></i>
        <p>loading</p>
      </div>
    </div>

  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    name: 'mcBaseLoading',
    props: {
      loading: false
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/base-loading.vue